/* ------------------------------------------------------------------ *
 * Products delivered per driver, for the /delivery-runs summary.
 *
 * GET /run/driver-stats?from=DD/MM/YYYY&to=DD/MM/YYYY — run sheets whose
 * delivery date falls in the range (both omitted = every run), totalled
 * per driver. Stops merge the same way the run cards count them.
 *
 * Resolves to [{ driver, products, runs, stops }], most products first.
 * `startDate` / `endDate` are DD/MM/YYYY, or null for "all dates".
 * ------------------------------------------------------------------ */

import axios from "../axiosConfig";
import { BASE_SERVER_URL } from "../sampleData";

export function fetchDriverDeliveryStats({ startDate, endDate } = {}) {
  const params = {};
  if (startDate) params.from = startDate;
  if (endDate) params.to = endDate;
  return axios
    .get(`${BASE_SERVER_URL}/run/driver-stats`, { params })
    .then((res) => {
      if (!res.data || res.data.status !== "success") {
        throw new Error((res.data && res.data.message) || "Couldn't load driver stats");
      }
      return res.data.response || [];
    });
}
